/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const commentLinesHaveBeenSelected = function(context, selector) {
  if (selector == null) { selector = '[data-line-comment]:checked'; }
  return $(context).find(selector).length > 0;
};

const collectSelectedCommentLines = function(context, selector) {
  let id;
  if (selector == null) { selector = '[data-line-comment]:checked'; }
  const template = $("#line-comment-template").clone();

  $.each($(context).find(selector), function(indexInArray, el) {
    const li = document.createElement("li");
    li.textContent = el.dataset.lineComment;
    return template.find("ul").append(li);
  });
  
  if ($(context).is("form")) {
    id = $(context).attr("id");
  } else {
    id = $(context).parents("form").first().attr("id");
  }

  template.find("button").attr("data-rel", id);

  return template.html();
};

const bindPurchaseOrderCommentLine = function() {
  const purchaseOrderPopoverConfig = {
    html: true,
    container: "body",
    selector: '[data-line-comment].plus',
    content(event){
      return collectSelectedCommentLines($(this).data('context'), '[data-line-comment]');
    }
  };
  
  return $('body').popover(purchaseOrderPopoverConfig);
};

const bindCommentLinePopover = function() {
  const popoverConfig = {
    html: true,
    container: "body",
    trigger: "manual",
    content(event){
      return collectSelectedCommentLines($(this).data('context'));
    }
  };

  $(".add_single_line_to_cart").popover(popoverConfig).on("show.bs.popover", () => $(".add_lines_to_cart").popover("hide"));

  $(".add_lines_to_cart").popover(popoverConfig).on("shown.bs.popover", () => $(".add_single_line_to_cart").popover("hide"));
};

const scrollToHash = function(hash) {
  if (hash) {
    const hash_name = hash.split('#')[1];
    let section = $(`a[name='${hash_name}']`);
    if (section.length === 0) { section = $("#"+hash_name); }

    if (section.length) {
      const navbar_height =  $('.navbar-fixed-top').height();
      const new_top = section.offset().top - navbar_height - 320; // two rows worth
      return window.scrollTo(0, new_top);
    }
  }
};
  
const watchQuantityField = function(fieldId) {
  $(document).on("keydown", fieldId, function(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      $(this).parents("form").submit();
      return;
    }
  });
      
  return $(document).on("input", fieldId, function(event) {

    const value = $(this).val();
    const url = $(this).data("url");
    const productId = $(this).data("product-id");
    
    if (!!value) {
      const availabilityAddon = $("#blank_line_item_row .availability_addon");
      const lineTotalField = $("#blank_line_item_row .line_item_total_amount");
      
      const ajaxConfig = {
        dataType: "json",
        url,
        data: { 
          purchase_order_item: { 
            quantity: value,
            product_id: productId
          }
        },
        success(data, textStatus) {
          availabilityAddon.replaceWith(data.purchase_order_item.availability_addon);
          return lineTotalField.html(data.purchase_order_item.total_amount);
        }
      };

      return $.ajax(ajaxConfig);
    }
  });
};

const getLineItemRowForQuery = function(source, targetRow, url, data) {
  const ajaxConfig = {
    url,
    data,
    beforeSend(jqXHR, settings){
      return $("#blank_line_item_message").html("<i class='fa-solid fa-circle-notch fa-spin' aria-hidden='true'></i> Recherche en cours...");
    },
    success(data, textStatus, jqXHR) {
      // Fix for #1250
      // As redirects are automatically followed, use a custom header instead
      if (jqXHR.getResponseHeader("X-AUTOCOMPLETE-REDIRECT")) {
        window.location = jqXHR.getResponseHeader("X-AUTOCOMPLETE-REDIRECT");
        return;
      }

      source.autocomplete('destroy'); // to avoid a leak
      targetRow.replaceWith(data);
    }
  };
  
  return $.ajax(ajaxConfig);
};

var bindAutoComplete = function(product_search_text_field) {
    const labels = product_search_text_field.data('i18n-labels');
    
    const substitution_label = labels.substitution;
    const advanced_search_label = labels.advanced;
    const more_results_label = labels.more;
    
    product_search_text_field.on("keydown", function(event) {
      if (event.keyCode === 13) { 
        // Fix for #1249
        // Let autocomplete handle the Enter key if a selection has been made
        if ($('.aa-cursor').length === 0) {
          const value = product_search_text_field.autocomplete("val");
          product_search_text_field.autocomplete("close");
          
          const data = {
            purchase_order_item: {
              searched_product_reference: value
            }
          };
          
          getLineItemRowForQuery($(this), $("#blank_line_item_row"), $(this).data("target-url"), data);
          
          return event.preventDefault();
        }
      }
    });
      
    const suggestion_template = function(object, forwarded_args) {
      let template = product_search_text_field.data("suggestion-template")
        .replace("{{id}}", object.id)
        .replace("{{active_sku}}", object.reference)
        .replace("{{designation}}",object.designation);

      let substitution_text = "";

      template = template.replace("{{id}}", object.id);
      if (object.is_substitute) {
        substitution_text = `<span class=\"substitution_marker\">${substitution_label}</span>`;
      }

      return template.replace("{{substitution_marker}}", substitution_text);
    };


    const dataSet = {
        source(query, cb) {
          return $.get(product_search_text_field.data("source"), {query}, data => cb(data.options, data.meta));
        },
        name: "remote",
        displayKey: "reference",
        templates: {
          empty(context, forwardedArgs) {
            if (forwardedArgs.more) {
              return $('<div class="tt-display-more-link">').append($('<a href="'+forwardedArgs.more+'">').text(advanced_search_label));
            } else {
              return null;
            }
          },
          suggestion: suggestion_template,
          footer(context, forwardedArgs) {
            if (forwardedArgs.more && !context.isEmpty) {
              return $('<div class="tt-display-more-link">').append($('<a href="'+forwardedArgs.more+'">').text(more_results_label));
            } else {
              return null;
            }
          }
        }
      };

    const options = {
        minLength: 3,
        debug: false,
        autoselect: false
      };

    const handleAutoCompleteSelection = function(event, suggestion, dataset) {
      const data = { 
        purchase_order_item: {
          product_id: suggestion.id,
          searched_product_reference: suggestion.reference
        }
      };
          
      return getLineItemRowForQuery($(this), $("#blank_line_item_row"), $(this).data("target-url"), data);
    };
      
    product_search_text_field.autocomplete(options, dataSet).bind('autocomplete:selected', handleAutoCompleteSelection);
    return product_search_text_field.select();
  };

$(document).on('value-fetcher:loadend', function() {
  // Handle the event when the value fetcher has finished loading
  bindCommentLinePopover();
});

$(document).ready(function() {

  bindCommentLinePopover();
  bindPurchaseOrderCommentLine();

  $(document).on("click", ".acknowledge_line_comment", function(event){
    const {
      rel
    } = event.currentTarget.dataset;
    return document.getElementById(rel).submit();
  });

  $(document).on("click", "a.line_comment_close_popover", function(event){
    event.preventDefault();
    $(".add_lines_to_cart").popover("hide");
    $(".add_single_line_to_cart").popover("hide");
    return $('[data-line-comment].plus').popover("hide");
  });

  $('[data-toggle="tooltip"]').tooltip();

  $(".sizes_help").popover({
    html: true,
    template: '<div class="popover" role="tooltip" style="max-width: 475px;"><div class="arrow"></div><h4 class="popover-title"></h4><div class="popover-content"></div></div>'
  });

  if ($(".callout_list_product").size() > 0) {
    const config = {
      html: true,
      trigger: "hover focus",
      placement: "top",
      content() {
        const url = $(this).data("src");
        const element = document.createElement("img");
        element.setAttribute("src", url);
        element.className = "product_callout_thumbnail";
        return element;
      }
    };

    $(".callout_list_product").popover(config);
  }

  $("#add_all_results_trigger").on("click", function(event) {
    $('.checkbox_selectable_row').prop('checked', true);
    return true;
  });

  $(".display_equivalence_link").on("click", function(event) {
    $($(this).data("target")).toggleClass("hidden");
    event.preventDefault();
    return false;
  });

  $(".select_all_rows").on("click", function(event) {
    return $(this).parents("table").find('.checkbox_selectable_row').prop('checked', $(this).is(":checked"));
  });

  $("td.select_on_click").on("click", function(event) {
    const element = $(this).parent().find('.checkbox_selectable_row');
    return element.prop('checked', !element.is(":checked"));
  });


  $(document).on("click", "button.add_single_line_to_cart", function(event) {
    $($(this).data("src")).find('.checkbox_selectable_row').prop('checked', true);

    event.preventDefault();

    if (commentLinesHaveBeenSelected($(this).data("context"))) {
      return $(this).popover("show");
    } else {
      this.disabled = true;
      return this.form.submit();
    }
  });

  $("button.add_lines_to_cart").on("click", function(event){
    if (commentLinesHaveBeenSelected($(this).data("context"))) {
      event.preventDefault();
      return $(this).popover("show");
    }
  });

  const product_search_text_field = $(".product_search_field");

  if (product_search_text_field.size() > 0) {
    bindAutoComplete(product_search_text_field);
    watchQuantityField("#purchase_order_item_quantity");
    $(document).on("click", "#confirm_autocomplete_selection", function(event) {
      event.preventDefault();

      const e = jQuery.Event("keydown");
      e.which = 13;
      e.keyCode = 13;

      return $("#purchase_order_items_form input[name=query]").trigger(e);
    });

    scrollToHash(window.location.hash); 
  }

  if ($('input[name=purchase_order_selection_type]').length > 0) {
    return $('input[name=purchase_order_selection_type]').on("click", function() {
      const target_name = $(this).data("display-target-name");
      const element = $(target_name);
      if ($(this).data('display-target') === true) {
        return element.removeClass("hidden");
      } else {
        return element.addClass("hidden");
      }
    });
  }
});
        